const locale = navigator.language;
const monthYear = new Intl.DateTimeFormat(locale, { month: "short", year: "numeric", timeZone: "UTC" });
const monthDay = new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", timeZone: "UTC" });

// Design privacy rule: small subscription counts display as 0; payouts still use the real count.
const MIN_DISPLAYED_SUBSCRIPTIONS = 10;

export const formatMonthYear = (iso: string): string => monthYear.format(new Date(iso));

export const formatMonthDay = (iso: string): string => monthDay.format(new Date(iso));

export const toUtcMonthStart = (date: Date, monthOffset = 0): string =>
    new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + monthOffset, 1)).toISOString();

export const toDisplayedSubscriptions = (count: number): number => (count < MIN_DISPLAYED_SUBSCRIPTIONS ? 0 : count);
